import { render, staticRenderFns } from "./B105.vue?vue&type=template&id=c08d3544&scoped=true"
import script from "./B105.vue?vue&type=script&lang=js"
export * from "./B105.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=c08d3544&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08d3544",
  null
  
)

export default component.exports